import React from 'react';
import { Section, InnerSection } from '../../../styles/section/section';
import {
  HeaderTextBlock,
  HeaderTextBlockTitle
} from '../../../styles/text-block/header-text-block';
import { useBreakpoint } from '../../../helpers/breakpoint-provider';
import { VideoCarousel } from '../../../styles/video-carousel';
import { sortArrayBasedonArrayOrder } from '../../../utils/sort-array-based-on-array-order';
import { useHomeContext } from '../context';
import { SendInViewEvent } from '../../../helpers/send-in-view-event';

export const QuickAnswers = () => {
  const data = useHomeContext();
  const { isClient } = useBreakpoint();
  const videos = data?.allStrapiVideo?.edges;
  const sortedVideoIds = data?.getSupportData?.videos;
  // API fallback for failure
  const tempSortedVideos = sortArrayBasedonArrayOrder(
    videos,
    sortedVideoIds,
    (x) => x.node.uid
  );
  const sortedVideos =
    tempSortedVideos && tempSortedVideos?.length > 0
      ? tempSortedVideos?.slice(0, 9)
      : videos?.slice(0, 9);

  const [ref] = SendInViewEvent({
    isLoading: data?.isLoading,
    component_name: 'home_quick_answers',
    data: {
      videos,
      sortedVideoIds,
      sortedVideos
    }
  });

  return (
    <Section ref={ref}>
      <HeaderTextBlock size="responsive">
        <HeaderTextBlockTitle>Quick Answers</HeaderTextBlockTitle>
      </HeaderTextBlock>

      <InnerSection>
        {isClient && sortedVideos && <VideoCarousel videos={sortedVideos} />}
      </InnerSection>
    </Section>
  );
};
